import {
	isPending,
	fetchReferralSuccess,
	fetchReferralFailure,
} from "./referralCodeSlice";
import { toast } from "react-toastify";
import { userLogOut } from "../admin-dashboard-page/userAction";
import { getRefCodeApi } from "../../apis/referralApi";

export const getRefCode = _id => async dispatch => {
	dispatch(isPending());

	const result = await getRefCodeApi(_id);

	if (result?.message === "logout user") {
		return dispatch(userLogOut());
	}

	result.status === "success"
		? dispatch(fetchReferralSuccess(result.codes))
		: dispatch(fetchReferralFailure(result)) && toast.warn(result.message);
};
